import { Rect, ArticleType } from "../Generated/ParticaAPI";
import { eParticaAction } from "./ParticaEvent";


// tslint:disable-next-line: max-classes-per-file
export enum LoadPageContent {
	Text = 1,
	Images = 2,
	All = 3
}

// tslint:disable-next-line: max-classes-per-file
export class PageContent {
	public src: string = "";
	public items: PageContentItem[] = [];
	public width: number = 0;
	public height: number = 0;
	public sorteditems(): PageContentItem[] {
		return this.items.sort((n1, n2) => n2.area - n1.area);
	}
}

// tslint:disable-next-line: max-classes-per-file
export class PageContentItem {
	public color: string;
	public action: string;
	public box: PageBox;
	public content: any;
	public contentstyled: any;
	public id: number;
	public type: string;
	public class: string = "rv-content-box ";
	public get area(): number {
		return this.box.area;
	}
}

// tslint:disable-next-line: max-classes-per-file
export class PageBox {
	public x: number = 0;
	public y: number = 0;
	public width: number = 0;
	public height: number = 0;
	public get area(): number {
		return this.width * this.height;
	}
	constructor(box: Rect | undefined) {
		if (box) {
			this.x = box.x1 === undefined ? 0 : box.x1;
			this.y = box.y1 === undefined ? 0 : box.y1;
			this.width = box.x2 === undefined ? 0 : box.x2 - this.x;
			this.height = box.y2 === undefined ? 0 : box.y2 - this.y;
		}
	}
}


export interface ParticaConfirmConfig {
	message: string;
	message2: string;
	title: string;
	show: boolean;
	item: any;
	action: eParticaAction;
}


export interface MenuItem {
	id: string;
	name: string;
	children: MenuItem[];
}

export enum ExtractionProperties {
	None,
	Title,
	Body,
	Images
}

export interface EnumDTO {
	label: string;
	value: any;
}
// tslint:disable-next-line: max-classes-per-file
/*export class MenuActionDTO {
	constructor(
		public action: eParticaAction,
		public display: string
	) { }
}*/

export interface IFormField {
	props: FormFieldProps;
	rules: FormFieldRules;
}

export interface FormFieldProps {
	label: string;
	name: string;
	placeholder: string;
	required: boolean;
	values: EnumDTO[];
	disabled: boolean;
}

export interface FormFieldRules {
	required: boolean;
	min: number;
	max: number;
	min_value: number;
	max_value: number;
	numeric: boolean;
	regex: string;
	confirmed: string;
	email: boolean;
	password: boolean;
	url: boolean;
	disabled: boolean;
	is_not: any;
	included: any[];
	excluded: any;
	decimal: number;
	digits: number;
}

export interface ParticaErrorData {
	error: any;
	friendly: string;
	apimessage: string;
	component: string;
	redirect: string;
	show: boolean;
}



